import ICompany from "@/interfaces/ICompany";
import ISession, { SessionMode } from "@/interfaces/ISession";

export const IS_PRODUCTION =
  process.env.NODE_ENV === "production" && !process.env.NEXT_PUBLIC_CF_ACCESS_DOMAIN;

export default function GetSessionMode(session: ISession, company: ICompany) {
  if (session.isTablet && company.license.tablet_slots > 0) {
    return SessionMode.Tablet;
  }

  if (
    (session.tableNumber || session.commandNumber) > 0 &&
    company.license.has_table_orders &&
    company.waiter.enable_table_orders
  ) {
    return SessionMode.Table;
  }

  return SessionMode.ReadOnly;
}

export function UseCommand(session: ISession, company: ICompany) {
  const mode = GetSessionMode(session, company);

  if (mode === SessionMode.Tablet) {
    return company.waiter.use_tablet_commands;
  }

  if (mode === SessionMode.Table) {
    return company.waiter.use_table_commands;
  }

  return false;
}

export function HasFixedTableNumber(mode: SessionMode) {
  return [SessionMode.Table, SessionMode.Tablet].includes(mode);
}

export function HasFixedTableOrder(mode: SessionMode) {
  return [SessionMode.Table, SessionMode.Tablet].includes(mode);
}

export function IsTabletMode(mode: SessionMode) {
  return mode === SessionMode.Tablet;
}
